import React, { useState } from "react";
import ButtonSubmit from "../../../Atomes/Buttons/ButtonSubmit";
import CardCircuitDeValidationStatus from "./CardCircuitDeValidationStatus";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import DirRespService from "../../../../services/Ing/DirResp/DirRespService";

export function CardCircuitDeValidationIng({
	id,
	title,
	styleButton,
	niceNames,
	img,
	numberFolder,
	status,
	color,
	niceStudyStatus,
	studyId,
	onApprovalCircuitReload,
}) {
	const [showPopUp, setShowPopUp] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const isMinorOrMajorDefault = styleButton === "orange" || styleButton === "red";

	const handleUnlockStudyFolder = async (unlock) => {
		if (isSubmitting) return;
		setIsSubmitting(true);
		try {
			const request = await DirRespService.validateTSR(studyId, { validation: unlock });
			if (request.request.status === 200) {
				if (unlock) {
					toast.success("Le tableau de synthèse des résultats a bien été validé.");
				} else {
					toast.success("Le tableau de synthèse des résultats a bien été désactivé.");
				}
				setShowPopUp(false);
				onApprovalCircuitReload?.();
			} else {
				toast.error("Une erreur est survenue.");
			}
		} catch (error) {
			toast.error("Une erreur est survenue.");
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<>
			<div className={"card-circuit-de-validation"}>
				<div className={"card-circuit-de-validation-img"}>
					<img src={`${process.env.REACT_APP_PROD_URL}${img}`} alt={niceNames ? niceNames : ""} />
				</div>
				<div className={"card-circuit-de-validation-name"}>
					<h4>{niceNames}</h4>
				</div>
				<div className={"card-circuit-de-validation-dossier"}>
					<p className="text-primary">{numberFolder}</p>
					<CardCircuitDeValidationStatus title={status} color={color} />
				</div>
				<ButtonSubmit
					onClick={() => {
						if (isMinorOrMajorDefault) {
							setShowPopUp(true);
						}
					}}
					title={niceStudyStatus}
					styleButton={`btn-default ${styleButton}`}
				/>
				<Link to={`/projet/${id}`}>Télécharger le tableau de synthèse des résultats</Link>
			</div>
			{showPopUp ? (
				<div className={"pop-up-base-style active"}>
					<div className={"pop-up-user-delete"}>
						<img
							onClick={() => setShowPopUp(false)}
							className={"cross-close"}
							src={"/images/pictos/cross-close.svg"}
							alt={"cross close"}
						/>
						<img src={"/images/medias/popup.svg"} alt="img form" />
						<h4>Vérification tableau de synthèse des résultats</h4>
						<p className="text-primary" style={{ paddingBottom: "20px" }}>
							Voulez-vous débloquer le dossier d&apos;étude structure en validant le tableau de synthèse des résultats ?
						</p>
						<div className={"pop-up-user-delete-buttons"}>
							<button className={"btn btn-cancel"} onClick={() => handleUnlockStudyFolder(false)} disabled={isSubmitting}>
								Non
							</button>
							<button
								className={"btn btn-primary"}
								onClick={() => handleUnlockStudyFolder(true)}
								disabled={isSubmitting}
							>
								Oui
							</button>
						</div>
					</div>
				</div>
			) : null}
		</>
	)
}

export default CardCircuitDeValidationIng;
